var map = {
	"./flag-AR.svg": "5666",
	"./flag-BO.svg": "776b",
	"./flag-BR.svg": "a00a",
	"./flag-CA.svg": "3e7d",
	"./flag-CL.svg": "eaec",
	"./flag-CO.svg": "e0b2",
	"./flag-DE.svg": "24bf",
	"./flag-EC.svg": "38c7",
	"./flag-ES.svg": "bf15",
	"./flag-FR.svg": "4656",
	"./flag-GB.svg": "e0f5",
	"./flag-IE.svg": "43cd",
	"./flag-IR.svg": "ce50",
	"./flag-IT.svg": "e687",
	"./flag-MX.svg": "53d1",
	"./flag-PE.svg": "15e3",
	"./flag-PT.svg": "3d7f",
	"./flag-PY.svg": "01f2",
	"./flag-US.svg": "a5f5",
	"./flag-UY.svg": "0f3c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6729";